// ReintroGate.js
//
// Cubre R9 — .claude/specs/rescate-inactivos/. Las cuentas del rescate de
// inactivos (`/me` → `reintro_pendiente: true`) ven la app "como si entraran por
// primera vez": acá se las lleva al onboarding de #1525 (/perfil/verificacion,
// paso Bienvenida) aunque estén aprobadas y con acceso. Sin UI propia: reusa el
// wizard tal cual.
//
// - Una sola vez por sesión del navegador (helpers/reintro.js, sessionStorage):
//   el wizard sale con `destinoSegunCuenta`, que con la marca puesta ya no
//   devuelve al wizard, así "Completar después" y "Atrás" llevan al Turno.
// - Solo desde /, /home y /turno (aterrizajes normales). Una cuenta que abre
//   /perfil o /admin no se redirige.
// - Nunca dos modales a la vez: mientras haya un gate de alta dibujado
//   (Términos, celular, perfil, prueba vencida) se espera; el effect vuelve a
//   evaluar cuando el gate se cierra y `currentUser` cambia.
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCurrentUser } from "../context/UserContext";
import { hayGateDeAltaActivo } from "../../helpers/turno-lugares-gate";
import {
  RUTAS_REINTRO,
  marcarReintroMostrada,
  reintroPorMostrar,
} from "../../helpers/reintro";

const ReintroGate = () => {
  const { currentUser, loading } = useCurrentUser();
  const location = useLocation();
  const navigate = useNavigate();

  const pendiente = !loading && reintroPorMostrar(currentUser);
  const enRutaDeAterrizaje = RUTAS_REINTRO.includes(location.pathname);
  const bloqueada = pendiente && hayGateDeAltaActivo(currentUser);

  useEffect(() => {
    if (!pendiente || !enRutaDeAterrizaje || bloqueada) return;
    marcarReintroMostrada();
    navigate("/perfil/verificacion", { replace: true, state: { reintro: true } });
  }, [pendiente, enRutaDeAterrizaje, bloqueada, navigate]);

  // Marcador para prod (el literal sobrevive al minificador). Oculto: no es UI.
  if (!pendiente || !enRutaDeAterrizaje) return null;
  return <span data-testid="reintro-pendiente" hidden />;
};

export default ReintroGate;
